import React, { useState, useEffect } from 'react';

import { Window } from '../../../contexts';

import AddProductView from './AddProductView';
import { MODE_ADDING, MODE_SUCCESS } from './constants';

const getWatchesCategoryId = () =>
  Window.CATEGORIES.find(category => category.url_name === 'watches')?.id;

const AddProduct = () => {
  const [mode, setMode] = useState(MODE_ADDING);
  const [created, setCreated] = useState(null);
  const [watchesCategoryId, setWatchesCategoryId] = useState(getWatchesCategoryId);

  // ?for_store=1 — set when Owner Admin → My Products opened this form, so a
  // master acting as a store submits FOR that store (store-catalog feature).
  const forStore = new URLSearchParams(window.location.search).get('for_store') === '1';

  useEffect(() => {
    if (watchesCategoryId) return;
    const interval = setInterval(() => {
      const id = getWatchesCategoryId();
      if (id) {
        setWatchesCategoryId(id);
        clearInterval(interval);
      }
    }, 200);
    return () => clearInterval(interval);
  }, [watchesCategoryId]);

  if (!watchesCategoryId) return null;

  return (
    <AddProductView
      categoryId={watchesCategoryId}
      mode={mode}
      created={created}
      forStore={forStore}
      onSuccess={(product) => { setCreated(product); setMode(MODE_SUCCESS); }}
      onAddAnother={() => { setCreated(null); setMode(MODE_ADDING); }}
    />
  );
}

export default AddProduct;
